import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import CustomModal from "../CustomModal"; // Make sure to import your CustomModal

function InstituteProgramCard({ programData }) {
  const AWS = process.env.REACT_APP_AWS_HOST;
  // const [showImportModal, setShowImportModal] = useState(false);
  // const [selectedFile, setSelectedFile] = useState(null);
  // const [isUploading, setIsUploading] = useState(false);
  // const [uploadError, setUploadError] = useState("");
  // const [uploadSuccess, setUploadSuccess] = useState("");
  const navigate = useNavigate();

  // Handle both old and new data structure
  const program = programData?.programInfo || programData;

  const {
    program_title: title,
    program_image: image,
    description,
    category,
    duration,
    price,
    discounted_price,
    external_url,
    slug,
    name,
    id: program_id,
  } = program || {};

  // Format price display
  const displayPrice = discounted_price || price || "0";
  const originalPrice =
    price && discounted_price && price !== discounted_price ? price : null;

  // const API_BASE_URL = process.env.REACT_APP_API_LMS;
  // const API_TOKEN = process.env.REACT_APP_API_TOKEN;
  // const USER_ID = "6148";
  // const ProgramId = "73";

  // const handleFileChange = (event) => {
  //   const file = event.target.files[0];
  //   setUploadError("");
  //   setUploadSuccess("");

  //   if (!file) return;

  //   // Validate file type (CSV or Excel)
  //   const validTypes = [
  //     "text/csv",
  //     "application/vnd.ms-excel",
  //     "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  //   ];

  //   const isValidType =
  //     validTypes.includes(file.type) || /\.(csv|xlsx|xls)$/i.test(file.name);

  //   if (isValidType) {
  //     // Replace the previously selected file with the new one
  //     setSelectedFile(file);
  //   } else {
  //     setUploadError("Please upload a valid CSV or Excel file.");
  //     event.target.value = "";
  //   }
  // };

  // // New function to remove selected file
  // const handleRemoveFile = () => {
  //   setSelectedFile(null);
  //   setUploadError("");
  //   setUploadSuccess("");

  //   const fileInput = document.getElementById("importFileInput");
  //   if (fileInput) {
  //     fileInput.value = "";
  //   }
  // };

  // const handleUpload = async () => {
  //   // Validation checks
  //   if (!selectedFile) {
  //     setUploadError("Please select a file first.");
  //     return;
  //   }

  //   if (!program_id) {
  //     setUploadError("Program ID is missing. Cannot upload students.");
  //     return;
  //   }

  //   setIsUploading(true);
  //   setUploadError("");
  //   setUploadSuccess("");

  //   try {
  //     const formData = new FormData();
  //     formData.append("user_id", USER_ID);
  //     formData.append("student_file", selectedFile);
  //     formData.append("program_id", ProgramId);

  //     const response = await fetch(`${API_BASE_URL}/api/upload-students`, {
  //       method: "POST",
  //       headers: {
  //         Authorization: API_TOKEN,
  //         Accept: "application/json",
  //       },
  //       body: formData,
  //     });

  //     const result = await response.json();

  //     if (response.ok) {
  //       setUploadSuccess(result.message || "Students uploaded successfully!");

  //       // Reset form after successful upload
  //       setTimeout(() => {
  //         setShowImportModal(false);
  //         setSelectedFile(null);
  //         setUploadSuccess("");

  //         const fileInput = document.getElementById("importFileInput");
  //         if (fileInput) {
  //           fileInput.value = "";
  //         }
  //       }, 2000);
  //     } else {
  //       if (result.errors) {
  //         const errorMessages = Object.values(result.errors).flat();
  //         setUploadError(errorMessages.join(", "));
  //       } else if (result.message) {
  //         setUploadError(result.message);
  //       } else {
  //         setUploadError("Upload failed. Please try again.");
  //       }
  //     }
  //   } catch (error) {
  //     setUploadError(
  //       "Network error. Please check your connection and try again."
  //     );
  //   } finally {
  //     setIsUploading(false);
  //   }
  // };

  // const handleCancel = () => {
  //   setShowImportModal(false);
  //   setSelectedFile(null);
  //   setUploadError("");
  //   setUploadSuccess("");

  //   const fileInput = document.getElementById("importFileInput");
  //   if (fileInput) {
  //     fileInput.value = "";
  //   }
  // };

  const handleMoreDetails = (e) => {
    e.preventDefault();
    e.stopPropagation();

    if (slug) {
      navigate(`/program-detail/${slug}`);
    }
  };

  return (
    <>
      {/* Removed the Link wrapper that was causing conflicts */}
      <div
        className="card rounded-4 overflow-hidden"
        style={{
          border: "1px solid #ffc53a",
          fontWeight: 600,
          transition: "transform 0.3s ease, background-color 0.4s ease",
          cursor: "pointer",
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.transform = "scale(1.05)";
          e.currentTarget.style.backgroundColor = "#fff7e6";
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.transform = "scale(1)";
          e.currentTarget.style.backgroundColor = "";
        }}
      >
        <div className="position-relative">
          <img
            className="card-img-top"
            src={image ? `${AWS}${image}` : ""}
            alt={title || "Program image"}
            loading="lazy"
            style={{ width: "100%", height: "200px", objectFit: "cover" }}
          />
          <span
            className="badge position-absolute top-0 end-0 m-2 rounded-pill"
            style={{
              fontSize: "0.75rem",
              backgroundColor: "#ffc53a",
              color: "black ",
            }}
          >
            {name || category || "Program Category"}
          </span>
        </div>

        <div className="card-body">
          <h5
            className="card-title text-dark"
            style={{
              display: "-webkit-box",
              WebkitLineClamp: "2",
              WebkitBoxOrient: "vertical",
              overflow: "hidden",
              textOverflow: "ellipsis",
              height: "38px",
            }}
          >
            {title || "Program Title"}
          </h5>
          <p
            dangerouslySetInnerHTML={{
              __html:
                program.detail_description?.replace(/<[^>]*>/g, "") ||
                "Description is not available",
            }}
            className="text-primary text-truncate-two-lines"
            style={{
              height: "38px",
              fontWeight: "normal",
            }}
          />

          <ul
            className="list-unstyled text-primary mb-3"
            style={{ fontWeight: "normal" }}
          >
            <li>
              <i className="bi bi-clock me-2"></i>
              Duration: {duration || "-"}
            </li>
            <li>
              <i className="bi bi-calendar-check me-2"></i>
              Start Date: Immediate
            </li>
            <li>
              <i className="bi bi-building me-2"></i>
              HunarHo
            </li>
          </ul>

          <div className="card-footer d-flex justify-content-end align-items-center border-top">
            <div className="d-flex gap-5 justify-content-center w-100">
              {/* <button
                className="btn px-3"
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  setShowImportModal(true);
                }}
                style={{
                  backgroundColor: "#ffc53a",
                  color: "#36348E",
                  border: "none",
                }}
              >
                Import Student
              </button> */}
              <button
                className="btn px-3"
                onClick={handleMoreDetails}
                style={{
                  backgroundColor: "#36348E",
                  color: "white",
                  border: "none",
                }}
              >
                More Details
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Import Student Modal */}
      {/* <CustomModal
        show={showImportModal}
        onClose={handleCancel}
        title="Import Student"
        width={700}
      >
        <div
          className="import-modal-content"
          style={{
            marginTop: "20px",
            padding: "20px",
            backgroundColor: "#fff",
            borderRadius: "12px",
            boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
          }}
        >
          {/* Error Message */}
          {/* {uploadError && (
            <div
              style={{
                backgroundColor: "#f8d7da",
                color: "#721c24",
                border: "1px solid #f5c6cb",
                borderRadius: "8px",
                padding: "12px",
                marginBottom: "20px",
                display: "flex",
                alignItems: "center",
                gap: "8px",
              }}
            >
              <i className="bi bi-exclamation-triangle-fill"></i>
              <span>{uploadError}</span>
            </div>
          )} */}

          {/* Success Message */}
          {/* {uploadSuccess && (
            <div
              style={{
                backgroundColor: "#d4edda",
                color: "#155724",
                border: "1px solid #c3e6cb",
                borderRadius: "8px",
                padding: "12px",
                marginBottom: "20px",
                display: "flex",
                alignItems: "center",
                gap: "8px",
              }}
            >
              <i className="bi bi-check-circle-fill"></i>
              <span>{uploadSuccess}</span>
            </div>
          )} */}

          {/* <div className="file-upload-section" style={{ marginBottom: "30px" }}>
            <label
              htmlFor="importFileInput"
              style={{
                display: "block",
                marginBottom: "15px",
                fontWeight: "600",
                color: "#2c3e50",
                fontSize: "18px",
                letterSpacing: "0.5px",
              }}
            >
              Upload CSV or Excel File:
            </label>
            <div
              style={{
                border: "2px dashed #36348E",
                borderRadius: "12px",
                padding: "20px",
                backgroundColor: "#f8f9fa",
                transition: "all 0.3s ease",
              }}
            >
              <input
                type="file"
                id="importFileInput"
                accept=".csv,.xlsx,.xls"
                onChange={handleFileChange}
                disabled={isUploading}
                style={{
                  width: "100%",
                  padding: "12px",
                  fontSize: "14px",
                  cursor: "pointer",
                }}
              />
            </div>
            {selectedFile && (
              <div
                style={{
                  marginTop: "12px",
                  padding: "12px",
                  backgroundColor: "#e3f2fd",
                  borderRadius: "8px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  gap: "12px",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    flex: 1,
                  }}
                >
                  <i
                    className="bi bi-file-earmark-text"
                    style={{ color: "#36348E" }}
                  ></i>
                  <p
                    style={{
                      margin: 0,
                      fontSize: "14px",
                      color: "#36348E",
                      fontWeight: "500",
                    }}
                  >
                    {selectedFile.name}
                  </p>
                </div>
                <button
                  onClick={handleRemoveFile}
                  disabled={isUploading}
                  style={{
                    background: "none",
                    border: "none",
                    color: "#dc3545",
                    fontSize: "16px",
                    cursor: isUploading ? "not-allowed" : "pointer",
                    padding: "4px",
                    borderRadius: "4px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    opacity: isUploading ? 0.5 : 1,
                    transition: "all 0.2s ease",
                  }}
                  onMouseEnter={(e) => {
                    if (!isUploading) {
                      e.target.style.backgroundColor = "#f8d7da";
                    }
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.backgroundColor = "transparent";
                  }}
                  title="Remove file"
                >
                  <i className="bi bi-x-lg"></i>
                </button>
              </div>
            )}
          </div> */}

          {/* <hr
            style={{
              border: "none",
              borderTop: "2px solid #f0f0f0",
              margin: "25px 0",
            }}
          /> */}

          {/* <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              gap: "15px",
            }}
          >
            <button
              onClick={handleCancel}
              disabled={isUploading}
              style={{
                padding: "12px 24px",
                border: "2px solid #36348E",
                borderRadius: "8px",
                backgroundColor: "white",
                color: "#36348E",
                cursor: isUploading ? "not-allowed" : "pointer",
                fontSize: "15px",
                fontWeight: "600",
                transition: "all 0.3s ease",
                opacity: isUploading ? 0.7 : 1,
              }}
            >
              Cancel
            </button>
            <button
              onClick={handleUpload}
              disabled={isUploading || !selectedFile}
              style={{
                padding: "12px 24px",
                border: "none",
                borderRadius: "8px",
                backgroundColor:
                  isUploading || !selectedFile ? "#ccc" : "#36348E",
                color: "white",
                cursor:
                  isUploading || !selectedFile ? "not-allowed" : "pointer",
                fontSize: "15px",
                fontWeight: "600",
                transition: "all 0.3s ease",
                boxShadow: "0 2px 6px rgba(54, 52, 142, 0.3)",
                display: "flex",
                alignItems: "center",
                gap: "8px",
              }}
            >
              {isUploading ? (
                <>
                  <i
                    className="bi bi-arrow-clockwise"
                    style={{
                      animation: "spin 1s linear infinite",
                    }}
                  ></i>
                  Uploading...
                </>
              ) : (
                <>
                  <i className="bi bi-cloud-upload"></i>
                  Upload
                </>
              )}
            </button>
          </div>
        </div> */}

        {/* Add CSS for spinner animation */}
        {/* <style>
          {`
            @keyframes spin {
              from { transform: rotate(0deg); }
              to { transform: rotate(360deg); }
            }
          `}
        </style> */}
      {/* </CustomModal> */}
    </>
  );
}

export default InstituteProgramCard;
